import { useEffect } from "react";
import { useTranslate } from "@refinedev/core";
import { notification } from "antd";
import { Button } from "@libertify/ui";

const NOTIFICATION_KEY = "enable-mfa-nudge";

export type EnableMfaToastProps = {
  open: boolean;
  onEnableNow: () => void;
  onSkip: () => void;
};

// One-time nudge shown to a signed-in user with no MFA factor enabled, as a
// dismissible top-right toast rather than a blocking modal. Both actions
// dismiss it for good — see useMfaSetupNudge.
export const EnableMfaToast = ({
  open,
  onEnableNow,
  onSkip,
}: EnableMfaToastProps) => {
  const t = useTranslate();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (!open) {
      api.destroy(NOTIFICATION_KEY);
      return;
    }
    api.open({
      key: NOTIFICATION_KEY,
      message: t("components.enableMfaModal.title"),
      description: t("components.enableMfaModal.description"),
      placement: "topRight",
      duration: 0,
      onClose: onSkip,
      btn: (
        <Button variant="primary" size="s" onClick={onEnableNow}>
          {t("components.enableMfaModal.enableNow")}
        </Button>
      ),
    });
  }, [open, api, onEnableNow, onSkip, t]);

  // Close the notification if this component ever unmounts mid-flow
  // (e.g. navigating away during onboarding) instead of leaving it stuck.
  useEffect(() => {
    return () => {
      api.destroy(NOTIFICATION_KEY);
    };
  }, [api]);

  return contextHolder;
};
